import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/svg/quiz/quiz-work-stage-contribution-preset.svg?data'
import _imports_1 from '@/assets/images/svg/quiz/quiz-work-stage-contribution-custom.svg?data'


const _hoisted_1 = { class: "grid grid-equalize" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "quiz-style-selection" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "quiz-style-selection" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Select ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuizSelectableButton = _resolveComponent("QuizSelectableButton")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Contribution stylin’",
    description: "How do you like to contribute to a team? We’ve got 2 choices for you below. You can either use one of our prebaked presets or get creative and make your own.",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[2] || (_cache[2] = ($event: any) => (_ctx.QuizService.close())),
    class: "quiz-work-stage-contribution-style",
    "is-vertically-aligned": true,
    prev: !_ctx.QuizService.editing.value
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        disabled: _ctx.selectedStyle === '',
        onClick: _ctx.navigateNext
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_QuizSelectableButton, {
            title: "Use preset",
            description: "Start with one of the preset personas",
            selected: _ctx.selectedStyle === _ctx.CONTRIBUTION_STYLES.PRESET,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedStyle = _ctx.CONTRIBUTION_STYLES.PRESET)),
            class: "quiz-style-button"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["selected"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_QuizSelectableButton, {
            title: "Custom",
            description: "Craft a persona from scratch",
            selected: _ctx.selectedStyle === _ctx.CONTRIBUTION_STYLES.CUSTOM,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedStyle = _ctx.CONTRIBUTION_STYLES.CUSTOM)),
            class: "quiz-style-button"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["selected"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back", "prev"]))
}